import * as Yup from 'yup';

import userFormModel from './userFormModel';

const {
  formField: {
    fullName,
    email,
    emailContact,
    registration,
    cpf,
    phone1,
    phone2,
    area,
    subArea,
    office,
    manager,
    specialNeed,
    zipCode,
    street,
    number,
    complement,
    district,
    city,
    state,
    profiles,
    groups,
  },
} = userFormModel;

export default [
  Yup.object().shape({
    [fullName.name]: Yup.string()
      .required(`${fullName.requiredErrorMsg}`)
      .matches(/(\w.+\s).+/i, `${fullName.invalidErrorMsg}`)
      .matches(/^.{1,60}$/, `${fullName.invalidSizeMsg}`),
    [email.name]: Yup.string()
      .matches(
        /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]/i,
        `${email.invalidErrorMsg}`,
      )
      .required(`${email.requiredErrorMsg}`),
    [emailContact.name]: Yup.string()
      .matches(
        /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]/i,
        `${emailContact.invalidErrorMsg}`,
      )
      .required(`${emailContact.requiredErrorMsg}`),
    [registration.name]: Yup.string(),
    [cpf.name]: Yup.string(),
    [phone1.name]: Yup.string(),
    [phone2.name]: Yup.string(),
    [area.name]: Yup.string().required(`${area.requiredErrorMsg}`),
    [subArea.name]: Yup.string(),
    [office.name]: Yup.string().required(`${office.requiredErrorMsg}`),
    [manager.name]: Yup.string(),
    [specialNeed.name]: Yup.bool().default(false),
  }),
  Yup.object().shape({
    [zipCode.name]: Yup.string(),
    [street.name]: Yup.string(),
    [number.name]: Yup.string(),
    [complement.name]: Yup.string(),
    [district.name]: Yup.string(),
    [city.name]: Yup.string(),
    [state.name]: Yup.string(),
  }),
  Yup.object().shape({
    [profiles.name]: Yup.array().min(1, `${profiles.requiredErrorMsg}`),
    [groups.name]: Yup.array().min(1, `${groups.requiredErrorMsg}`),
  }),
];
